import { Link } from 'react-router-dom';
import Stars from '../Stars/Stars';
import './PostCard.css';

function PostCard({ post }) {
  const firstBodyParagraph = post.body?.find((b) => typeof b === 'string') ?? null;

  return (
    <Link to={`/post/${post.slug}`} className="post-card">
      <div className="post-card-image-wrap">
        <img src={post.thumbImage} alt={post.title} className="post-card-image" />
        {post.isNew && <span className="post-card-new-badge">New</span>}
      </div>
      <div className="post-card-body">
        <div className="post-card-meta">
          <p className="post-card-date">{post.date}</p>
          <div className="post-card-meta-right">
            {post.rating && <Stars rating={post.rating} className="light" />}
            {post.cost != null && <span className="post-card-cost">£{post.cost.toFixed(2)}</span>}
          </div>
        </div>
        <h2 className="post-card-title">{post.title}</h2>
        <p className="post-card-blurb">{post.blurb}</p>
        {firstBodyParagraph && (
          <p className="post-card-preview">{firstBodyParagraph}</p>
        )}
        <div className="post-card-footer">
          {post.tags?.length > 0 && (
            <div className="post-card-tags">
              {post.tags.map((tag) => (
                <span key={tag} className="post-card-tag">{tag}</span>
              ))}
            </div>
          )}
          <span className="post-card-read-more">Read more →</span>
        </div>
      </div>
    </Link>
  );
}

export default PostCard;
